// extracted by mini-css-extract-plugin
export default {"fullWidth":"uo-z","image":"vo-z","lazyLoadPicture":"wo-z","lazyLoadSpinner":"xo-z","lazyLoadSpin":"yo-z","lazyLoadImage":"zo-z","hasStyledAspectRatio":"Ao-z"};